import React, { useEffect, useRef, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { Tooltip } from 'react-tooltip';
import { useAudioTrack, useScreenShare } from '@daily-co/daily-react';
import {
  DefaultParticipantIcon,
  ExpandArrows,
  MicrophoneOff,
  MicrophoneOn,
} from '../../../Tray/Icons';
import Username from '../../../Username/Username';
import './ParticiantItem.css';
import { selectedParticipantIdState, teacherScreenViewState } from '../../../../state/viewModeAtom';
import viewModes from '../../../../Constants/viewModes';

export default function ParticipantItem({ participantId, isTeacher, toggleAudio }) {
  const audioTrack = useAudioTrack(participantId);
  const isMuted = audioTrack?.isOff ?? true;
  const setSelectedParticipantId = useSetRecoilState(selectedParticipantIdState);
  const setViewMode = useSetRecoilState(teacherScreenViewState);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { screens } = useScreenShare();
  const isParticipantSharingScreen = screens.some((screen) => screen.session_id === participantId);

  const handleDropdownToggle = () => {
    if (isTeacher) {
      setIsDropdownOpen((prev) => !prev);
    }
  };

  const toggleParticipantScreen = () => {
    setSelectedParticipantId(participantId);
    setViewMode(viewModes.SINGLE);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      className="participant-list-item-button"
      onClick={handleDropdownToggle}
      role="button"
      tabIndex={0}
      onKeyPress={handleDropdownToggle}>
      <div key={participantId} className="participant-item">
        <div className="user-info">
          <DefaultParticipantIcon />
          <Username id={participantId} />
        </div>

        {isDropdownOpen && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div ref={dropdownRef} className="tooltip-dropdown" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="tooltip-item"
              disabled={!isParticipantSharingScreen}
              onClick={toggleParticipantScreen}>
              <ExpandArrows />
              <div>Atidaryti per visą ekraną</div>
            </button>
          </div>
        )}

        {isTeacher && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleAudio(participantId, !audioTrack.isOff);
              }}
              type="button"
              className="mute-participant-button"
              data-tooltip-id={`tooltip-${participantId}`}
              data-tooltip-content={isMuted ? '' : 'Nutildyti'}>
              {isMuted ? <MicrophoneOff /> : <MicrophoneOn />}
            </button>
            <Tooltip id={`tooltip-${participantId}`} delayShow={200} />
          </>
        )}
      </div>
    </div>
  );
}
